import { render } from "./NavigationPortal.vue?vue&type=template&id=06ac0494&ts=true"
import script from "./NavigationPortal.vue?vue&type=script&lang=ts"
export * from "./NavigationPortal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__